import { Check } from "lucide-react";
import { Badge } from "../../../ui/common/badge";
import { cn } from "../../../../lib/utils";
import { VersionBadgeTone } from "../types/versionHistory.types";

interface VersionStatusBadgeProps {
  tone: VersionBadgeTone;
  label: string;
}

const TONE_CLASSNAME: Record<VersionBadgeTone, string> = {
  [VersionBadgeTone.Active]: "tw-bg-success/10 tw-text-success tw-border-success/30",
  [VersionBadgeTone.Calculated]: "tw-bg-secondary tw-text-secondary-foreground",
  [VersionBadgeTone.NotCalculated]: "tw-bg-warning/10 tw-text-warning tw-border-warning/30"
};

export const VersionStatusBadge = ({ tone, label }: VersionStatusBadgeProps) => (
  <Badge variant="outline" className={cn("tw-rounded-full tw-px-2.5 tw-text-xs tw-font-medium tw-gap-1", TONE_CLASSNAME[tone])}>
    {tone === VersionBadgeTone.Active ? <Check className="tw-h-3 tw-w-3" /> : null}
    {label}
  </Badge>
);
